"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _colors = require("../../../styles/colors");

var _shadows = require("../../../styles/shadows");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    width: 0.5rem;\n    height: 0.5rem;\n    background: ", ";\n    border-radius: 50%;\n    border: 1px solid ", ";\n    padding: 0;\n\n    :hover {\n        background-color: ", ";\n        border: 1px solid ", ";\n    }\n\n    :focus {\n        outline: 0;\n        box-shadow: ", ";\n        border: 1px solid ", ";\n    }\n\n    ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledIndicatorButton = _styledComponents["default"].button(_templateObject(), _colors.COLOR_GRAY_2, _colors.COLOR_GRAY_2, _colors.COLOR_GRAY_3, _colors.COLOR_GRAY_3, _shadows.SHADOW_OUTLINE, _colors.COLOR_BRAND_ACTIVE, function (props) {
  return props.isSelected && "\n            background: ".concat(_colors.COLOR_BRAND, ";\n            border: 1px solid ").concat(_colors.COLOR_BRAND, ";\n\n            :hover {\n                background: ").concat(_colors.COLOR_BRAND_ACTIVE, ";\n                border: 1px solid ").concat(_colors.COLOR_BRAND_ACTIVE, ";\n            }\n        ");
});

var _default = StyledIndicatorButton;
exports["default"] = _default;